import { render } from "./CampaignsQuickGuide.vue?vue&type=template&id=65e41c10"
const script = {}

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__